import { render, staticRenderFns } from "./StzhButtonComponent.vue?vue&type=template&id=784f9bd8&scoped=true"
import script from "./StzhButtonComponent.vue?vue&type=script&lang=js"
export * from "./StzhButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./StzhButtonComponent.vue?vue&type=style&index=0&id=784f9bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784f9bd8",
  null
  
)

export default component.exports